import { Badge, ClockIcon } from '@paypalcorp/pp-react';
import * as React from 'react';
export default {
  Badge,
  ClockIcon,
  React
};